
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'accordionComponent',
  props: {
    group: String,
    title: String
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    toggleClass () {
      this.isActive = !this.isActive
    }
  },
})
